import { useState } from "react";

import type { GameType } from "~/components/GameContext";

export const useGameState = (game: GameType) => useState(game);
